export default {"src":"/blogs/_next/static/media/karePediaFirstLogo.ecfe5339.gif","height":93,"width":145,"blurWidth":0,"blurHeight":0};